const resultsModule = {
namespaced: true,
state: {
    results: [],
    totalRecordCount: 0,
    perfectMatchCount: 0,
    isLoading: false,
    pageSize: 5,
    pageLoaded: 0,
    searchForSimilar: false
},
actions: {
    setResults({commit}, results) {
        commit('setResults', results);
    },
    setTotalRecordCount({commit}, totalRecordCount) {
        commit('setTotalRecordCount', totalRecordCount);
    },
    setPerfectMatchCount({commit}, perfectMatchCount) {
        commit('setPerfectMatchCount', perfectMatchCount);
    },
    setLoading({commit}, isLoading) {
        commit ('setLoading', isLoading);
    },
    setPageSize({commit}, pageSize) {
        commit ('setPageSize', pageSize);
    },
    setPageLoaded({commit}, pageLoaded) {
        commit ('setPageLoaded', pageLoaded);
    },
    clearResults({commit}) {
        commit('clearResults');
    },
    setSearchForSimilar({commit}, similar) {
        commit ('setSearchForSimilar', similar);
    }
},
getters: {
    getTotalRecordCount(state) {
        return state.totalRecordCount;
    },
    getPerfectMatchCount(state) {
        return state.perfectMatchCount;
    },
    getLoading(state) {
        return state.isLoading;
    },
    getResults(state) {
        return state.results;
    },
    getPageSize(state) {
        return state.pageSize;
    },
    getPageLoaded(state) {
        return state.pageLoaded;
    },
    getPaginationLength(state) {
        return Math.ceil(state.totalRecordCount / state.pageSize);
    },
    getSearchForSimilar(state) {
        return state.searchForSimilar;
    }
},
mutations: {
    setResults(state, results) {
        state.results = results;
    },
    setTotalRecordCount(state, totalRecordCount) {
        state.totalRecordCount = totalRecordCount;
    },
    setPerfectMatchCount(state, perfectMatchCount) {
        state.perfectMatchCount = perfectMatchCount;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setPageSize(state, pageSize) {
        state.pageSize = pageSize;
    },
    setPageLoaded(state, pageLoaded) {
        state.pageLoaded = pageLoaded;
    },
    clearResults(state) {
        state.results = [];
    },
    setSearchForSimilar(state, similar) {
        state.searchForSimilar = similar;
    }
}
}

export default resultsModule;